import './index.css';

import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { RouterProvider } from 'react-router';

import { i18n } from './i18n';
import { startPwa } from './lib/pwa-control';
import { queryClient } from './lib/queryClient';
import { DisplayProvider } from './providers/display-provider';
import { router } from './router';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found in index.html');

// AgDR-0269: read the PWA control file, then register the worker if allowed.
// Nothing else is sent at start: no web vitals, no product events, no feedback queue and no
// remote settings, since the app has no server of its own (AgDR-LOCAL-0001, qg#185 point 7).
void startPwa();

createRoot(rootElement).render(
  <StrictMode>
    {/* AgDR-0039, AgDR-0288 §3: the person's density and text size (100 % to 200 %). */}
    <DisplayProvider>
      <I18nextProvider i18n={i18n}>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </I18nextProvider>
    </DisplayProvider>
  </StrictMode>,
);
